import {loadElementLottie, playLottie} from "./animations/lottie";

export function toggleBook() {

    let book = $('.js-book')

    book.each(function () {
        let me = $(this);
        let el = me.find(".js-load-lottie")
        let cart = me.find(".js-load-lottie-cart")

        me.find("a.book-open").on({
            mouseenter: function () {
                if ( window.innerWidth > 1279 ) {
                    playLottie(el)
                }
            },
            mouseleave: function () {}
        });

        me.find("a.book-buy").on({
            mouseenter: function () {
                if ( window.innerWidth > 1279 ) {
                    playLottie(cart)
                }
            },
            mouseleave: function () {}
        });

    })

}

export function openBook(me) {

    let book = me.closest('.js-book')
    let inside = book.find(".js-load-lottie-inside")
    let el = book.find(".js-load-lottie")
    let single_p = book.parent().siblings();

    loadElementLottie(inside, el)

    book.find(".details a.book-open.link-with-icon").on({
        mouseenter: function () {
            if ( window.innerWidth > 1279 ) {
                playLottie(inside)
            }
        },
        mouseleave: function () {}
    });

    book.addClass('details-open')

    single_p.each(function() {
        let m = $(this)
        let b = m.find('.js-book')
        b.removeClass('details-open')
    });

    return false

}

export function closeBook(me) {
    me.closest('.js-book').removeClass('details-open')
    return false
}